import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth/auth.guard';
import { nonAuthGuard } from '@guards/non-auth/non-auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/events/events.routes').then(m => m.routes),
        canActivate: [authGuard]
    },
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login-page.component').then(m => m.LoginPageComponent),
        canActivate: [nonAuthGuard]
    },
    {
        path: 'lost-pw',
        loadComponent: () => import('./pages/lostpw/lostpw-page.component').then(m => m.LostPwPageComponent),
        canActivate: [nonAuthGuard]
    },
    {
        path: 'set-pw',
        loadComponent: () => import('./pages/setpw/setpw-page.component').then(m => m.SetpwPageComponent),
        canActivate: [nonAuthGuard]
    },
    {
        path: 'register',
        loadComponent: () => import('./pages/register/register-page.component').then(m => m.RegisterPageComponent),
        canActivate: [nonAuthGuard]
    },
    {
        path: '404',
        loadComponent: () => import('./pages/notfound/notfound-page.component').then(m => m.NotfoundPageComponent)
    },
    {
        path: '503',
        loadComponent: () => import('./pages/error/error-page.component').then(m => m.ErrorPageComponent)
    },
    { path: '**', redirectTo: '404' }
];
